import { getHostCMS } from '../api-wrapper/api-config';
import { cmsRequest } from './cmsRequest';

const HOST = getHostCMS(window.location.host);
const SHOW_UNPUBLISHED_CONTENT = 1;

function _searchImgDestination(data) {
  let response = data.find(dataCMS => {
    return dataCMS.bannerImageDesk !== '' ? dataCMS : null;
  });
  response = response !== null && response !== undefined ? response : data[0];
  return response;
}

export async function getAirportsCMS(language, signal) { // listo para migración@BAU21-716
  return cmsRequest({ url: `${HOST}/airports?language=${language}&status=${SHOW_UNPUBLISHED_CONTENT}`, method: 'get' }, signal);
}

/**
* @param {String} language - Language code
* @param {String} airportCode - e.g. JFK. The CMS uses the field 'cityCode' to filter results.
*/
export async function getDestinationInfo(language, airportCode, signal) {
  return cmsRequest({ url: `${HOST}/destination-info?language=${language}&cityCode=${airportCode}&status=${SHOW_UNPUBLISHED_CONTENT}`, method: 'get' }, signal)
    .then(data => _searchImgDestination(data));
}

export async function getStoreFronts(signal) {
  return cmsRequest({ url: `${HOST}/storefront/`, method: 'get' }, signal);
}

/**
 * Obtiene las validaciones web (TH Web Validations) desde el CMS.
 * De este servicio se consume `numberOfDecimalsBE` (antes se leía del storefront).
 * @param {String|Number} storefrontId - Id del storefront (ej. 355)
 * @param {AbortSignal} signal - Señal opcional de cancelación
 */
export async function getWebValidations(storefrontId, signal) {
  return cmsRequest({ url: `${HOST}/th-web-validations?storefront=${storefrontId}`, method: 'get' }, signal);
}

export async function getElectronicVisas(signal) {
  return cmsRequest({ url: `${HOST}/electronic-visas`, method: 'get' }, signal);
}

export async function getLanguageBundle(endpoint, signal) {
  return cmsRequest({ url: `${HOST}${endpoint}`, method: 'get' }, signal);
}

export async function getAncillariesCMS(options, signal) {
  return cmsRequest({ url: `${HOST}/ancillaries?language=${options.language}&status=${options.status}`, method: 'get' }, signal);
}

export async function getAncillaryMybCMS(options, signal) {
  return cmsRequest({ url: `${HOST}/ancillarymyb?language=${options.language}&status=${options.status}`, method: 'get' }, signal);
}

export async function getAmaiaFaq(storefront, status, signal) {
  return cmsRequest({ url: `${ HOST }/amaia?storefront=${ storefront }&status=${ status }`, method: 'get' }, signal);
}

export async function getSeatMapBannerCMS(options, signal) {
  return cmsRequest({ url: `${HOST}/seatmap_banners?language=${options?.language}&status=${options?.status}`, method: 'get' }, signal);
}

export async function getMybMigrationDocsCMS(options, signal) {
  return cmsRequest({ url: `${HOST}/checkin-migration-docs?language=${options.language}&status=${options.status}`, method: 'get' }, signal);
}

export async function getCountriesCMS(options, signal) { // faltan servicios de test y live probado en pre-live@BAU21-716
  return cmsRequest({ url: `${HOST}/countries?language=${options.language}&status=${SHOW_UNPUBLISHED_CONTENT}`, method: 'get' }, signal);
}

export async function getControlPanelCMS(signal) {
  return cmsRequest({ url: `${HOST}/control-panel/`, method: 'get' }, signal);
}

export async function getErrorMessageCMS(errorCode, language, signal) {
  if (!language || !errorCode) {
    return null;
  }
  return cmsRequest({ url: `${HOST}/error-messages?id=${errorCode}&language=${language}&status=${SHOW_UNPUBLISHED_CONTENT}`, method: 'get' }, signal);
}

export async function getMenuPromotionsCMS(storefrontId, signal) {
  return cmsRequest({ url: `${HOST}/menu-promotions?storefront_id=${storefrontId}&status=${SHOW_UNPUBLISHED_CONTENT}`, method: 'get' }, signal);
}

export async function getTravelInformationCMS(storefrontId, signal) {
  return cmsRequest({ url: `${HOST}/travel_information?storefront_id=${storefrontId}&status=${SHOW_UNPUBLISHED_CONTENT}`, method: 'get' }, signal);
}

export async function getAirportsLite(language, signal) { // faltan servicios de test y live probado en pre-live@BAU21-716
  return cmsRequest({ url: `${HOST}/airportslite?language=${language}&status=${SHOW_UNPUBLISHED_CONTENT}`, method: 'get' }, signal);
}

export async function getBannerCobrandAffiliate(language, signal) {
  return cmsRequest({ url: `${HOST}/banner-cobrand-affiliation?language=${language}&flujo=myb`, method: 'get' }, signal);
}

export async function getPersonalizedAcquisitionCobrand(language, signal) {
  return cmsRequest({ url: `${HOST}/personalized-acquisition-cobrand?language=${language}&status=${SHOW_UNPUBLISHED_CONTENT}&flow=3`, method: 'get' }, signal);
}

export async function getInfoSignUpPopUp(storeFront, section, signal) {
  return cmsRequest({ url: `${HOST}/signup-popup?storefront_id=${storeFront}&status=${SHOW_UNPUBLISHED_CONTENT}&section=${section}`, method: 'get' }, signal);
}

export async function getBrandedBenefits(market, region, language, signal) {
  return cmsRequest({ url: `${HOST}/family-tax-benefits?market=${market}&region=${region}&language=${language}&status=1`, method: 'get' }, signal);
}

export async function getInfoTouchPoints(storefrontId, signal) {
  return cmsRequest({ url: `${HOST}/touchpoints?storefront_id=${storefrontId}&status=${SHOW_UNPUBLISHED_CONTENT}&promo_id=none`, method: 'get' }, signal);
}

export async function getRefundReason(subcodes, language, signal) {
  return cmsRequest({ url: `${HOST}/errors-refund/${subcodes}?language=${language}&status=${SHOW_UNPUBLISHED_CONTENT}`, method: 'get' }, signal);
}

export async function getErrorCms(codeError, language, signal) {
  return cmsRequest({ url: `${HOST}/errors_api?id=${codeError}&language=${language}`, method: 'get' }, signal)
    .then(data => (Array.isArray(data) && data.length > 0 ? data[0] : null));
}

export async function getMealPreselectFlights(signal) {
  return cmsRequest({ url: `${HOST}/banner-meal-preselect?&status=${SHOW_UNPUBLISHED_CONTENT}`, method: 'get' }, signal);
}